import { WebEDIErrorsService } from './webediErrors';

export const WebEDIErrorsServiceSingleton = new WebEDIErrorsService();
